<template>
  <section class="container">
    <ClientOnly>
      <div
        class="row"
        data-aos="fade-up"
        data-aos-once="true"
        data-aos-duration="1500"
      >
        <span class="heading  heebo_text col-12 col-xl">{{ $t("stay_up_to_date") }}</span>
        <div class="w-100 col-12 col-xl">
          <p class="fs-4 heebo_text">
            {{ $t("news_letter") }}
          </p>
          <form id="form-1" method="post" @submit.prevent="signUp">
            <div class="w-100 row">
              <span class="w-100 col-sm">
                <input
                  type="email"
                  name="EMAIL"
                  placeholder="Your email address"
                  :aria-label="$t('stay_up_to_date')"
                  required=""
                  v-model="email"
                  class="form-fields w-100 mb-4 mb-sm-0 fs-4 fs-lg-2"
                />
              </span>

              <span class="w-100 col-sm ps-2">
                <button class="form-button-black" :disabled="isSubmitting || coolingDown || submissionDisabled" @click="rez">
                  {{ $t("sign_up") }}
                </button>
              </span>
            </div>
          </form>
        </div>
      </div>
      <div></div>
    </ClientOnly>
  </section>
</template>
<script>
import { load } from "recaptcha-v3";

const RECAPTCHA_SITE_KEY = '6LdG4wEuAAAAANgzhUk1FjsnfXkmLtxG5UYnDvTK'

// The newsletter is on most pages, so unlike the contact/career forms the
// reCAPTCHA script is only loaded when someone actually signs up, not on
// every page view. It goes through the same loader (and options) as their
// vue-recaptcha-v3 plugin, so whichever loads first they share one script
// and widget. Calling grecaptcha.execute(siteKey) directly on the plugin's
// explicitly rendered widget fails with "Invalid site key or not loaded in api.js".
const loadRecaptcha = () =>
  load(RECAPTCHA_SITE_KEY, { useRecaptchaNet: true, autoHideBadge: true })

export default {
  data() {
    return {
      email: null,
      isSubmitting: false,
      // Keeps the button disabled for a minute after a sign-up attempt
      // (double submits / spam).
      coolingDown: false,
      // Kill switch for spam waves: set to true to disable the button and
      // stop sign-ups without touching the rest of the form.
      submissionDisabled: false,
    };
  },
  methods: {
    async signUp() {
      if (this.isSubmitting || this.coolingDown || this.submissionDisabled) return;
      // Check if email is provided
      if (!this.email) {
        alert("Please enter a valid email address.");
        return;
      }

      this.isSubmitting = true;
      try {
        const recaptcha = await loadRecaptcha();
        const token = await recaptcha.execute("subscribe");
        if (!token) {
          alert("Invalid reCAPTCHA. Please try again.");
          return;
        }

        // The token goes with the subscription and the backend verifies it
        // there (reCAPTCHA tokens are single-use, so it can't be checked twice).
        const response = await fetch(
          "https://api2.salamisbayconti.com/api/forms/subscriptions",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              email: this.email,
              recaptcha_token: token,
            }),
          }
        );

        // Check if the response is okay (status in the range 200-299)
        if (response.ok) {
          const result = await response.json();
          console.log("Response:", result);
          alert("Subscription successful!"); // Notify user of success
          this.resetForm(); // Reset the form after successful submission
        } else {
          const error = await response.json();
          alert("Error: " + (error.message || "Failed to subscribe."));
        }
      } catch (error) {
        console.error("Error submitting data:", error);
        alert("An error occurred while submitting your subscription.");
      } finally {
        this.isSubmitting = false;
        this.coolingDown = true;
        setTimeout(() => {
          this.coolingDown = false;
        }, 60000); // Re-enable after 1 minute
      }
    },
    resetForm() {
      this.email = null; // Clear the email field
    },
  },
  computed: {
    language() {
      return this.$i18n.locale;
    },
  },
};
</script>
<style scoped>
.form-button-black:disabled,
.form-button-black:disabled:hover {
  opacity: 0.5;
  cursor: not-allowed;
  scale: 1;
}
.container {
  margin-inline: auto;
  margin-block: 8%;
  padding-inline: 5%;
}
@media (min-width:769) and (max-width: 1399px) {
  .container {
    margin-block: auto;    
  }
  .heading {
    margin-block: auto;
  }
}
.heading {
    margin-bottom: 1rem;
    font-size: 2.1rem;
    font-weight: 500;
  }
@media screen and (max-width: 768px) {
  .container {
    grid-template-rows: 2fr;
    font-size: 12px;
    padding-block: 50px;
    margin: 10px;
  }
  .heading {
    margin-bottom: 1rem;
    font-size: 1.5rem;
  }
}
@media (min-width: 2200px) {
  .container {
    margin-block: 180px;
  }
}

</style>
